import { type RefSelectProps, Select } from 'antd'
import clsx from 'clsx'
import { forwardRef, type Ref } from 'react'

import { type SingleOrMultipleSelectProps } from '@/components/types'
import { STATUSES } from '@/constants/common/message.constants'
import {
  type BankAccountType,
  BANK_ACCOUNT_TYPE,
  BANK_ACCOUNT_TYPE_LABEL
} from '@/libs/api/types'
import { useSelectOnChangeHandler } from '@/libs/hooks'

type Props = SingleOrMultipleSelectProps<BankAccountType, BankAccountTypeOption>

type BankAccountTypeOption = { label: string; value: BankAccountType }

const options: BankAccountTypeOption[] = Object.values(BANK_ACCOUNT_TYPE).map(
  (type) => ({
    label: BANK_ACCOUNT_TYPE_LABEL[type],
    value: type
  })
)

/**
 * 銀行口座種別を選択するSelect
 */
export const BankAccountTypeSelect = forwardRef(
  (
    {
      className,
      placeholder = STATUSES.UNSELECTED,
      value,
      mode,
      onChange,
      ...props
    }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    const handleChange = useSelectOnChangeHandler({ mode, onChange })
    return (
      <Select
        ref={ref}
        {...props}
        mode={mode}
        value={value}
        onChange={handleChange}
        className={clsx(['min-w-[140px]', className])}
        options={options}
        placeholder={placeholder}
      />
    )
  }
)
